import { find, isEmpty, map } from "lodash";
import React, { useState } from "react";

import Dropdown from "../dropdown";
import Button from "../button/Button";
import PlaylistSong from "../playlistSong/PlaylistSong";
import { scheduleConstants } from "../../constants";
import { getFormattedTime } from "./helpers";
import { showToaster } from "../../helpers/toaster.helpers";
import playlistStore from "../../zustand/playlist.store";
import SchedulesStore from "../../zustand/Schedule.store";
import { scheduleActions } from "../../actions";

import styles from "./scheduleToPlaySongPopUp.module.scss";
import userStore from "../../zustand/user.store";

const ScheduleToPlaySongPopUp = ({
  playlistId,
  setIsVisible,
  from,
  setVisible,
}) => {
  const arr = scheduleConstants.DAYS;
  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));

  const { playlists } = playlistStore((state) => ({
    playlists: state.playlists,
  }));

  const { addORUpdateSchedule } = SchedulesStore((state) => ({
    addORUpdateSchedule: state.addORUpdateSchedule,
  }));

  const [values, setValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleSetPlayingHour = (id) => (e) => {
    // console.log(e, "e");
    // console.log(id, "id-------");
    setValues({
      ...values,
      selectedPlayingHours: {
        ...values.selectedPlayingHours,
        [id]: e.value,
      },
    });
  };

  const setSelectedPlaylist = (id) => {
    if (!isEmpty(values)) {
      if (values?.selectedPlaylists[id]) {
        const selectedPlaylists = { ...values.selectedPlaylists };
        delete selectedPlaylists[id];
        setValues({
          selectedPlaylists: { ...selectedPlaylists },
        });
        return;
      }
    }

    setValues({
      selectedPlaylists: { ...values.selectedPlaylists, [id]: id },
    });
  };

  const handleSave = async () => {
    const days = map(values.selectedPlaylists, (day, index) => {
      return day;
    });
    if (isEmpty(days)) {
      showToaster("error", "Please select at least one day");
      return;
    }

    const selectedTime = getFormattedTime(values.selectedPlayingHours);

    const isScheduleAlreadyAdded = map(playlists, (i) => {
      if (i.schedule) {
        return i.schedule.find(
          (i) =>
            i.time === selectedTime && i.days.some((day) => days.includes(day))
        );
      }
      return false;
    }).some((i) => i);

    if (isScheduleAlreadyAdded) {
      showToaster("error", "Schedule already added");
      return;
    }
    const playlistData = find(playlists, (i) => i.id === playlistId);

    const schedule = {
      is_shuffled: false,
      start_time: getFormattedTime(values.selectedPlayingHours),
      days,
      playlist_id: playlistId,
    };

    setIsLoading(true);
    const updatedSchdule = await scheduleActions.createSchedule(
      schedule,
      userOffline
    );
    setIsLoading(false);
    setIsVisible(false);
    if (setVisible) setVisible(false);
    if (isEmpty(updatedSchdule)) return;

    addORUpdateSchedule({
      ...updatedSchdule,
      name: playlistData.name,
      color: playlistData.color,
      thumbnail_img: playlistData.thumbnail_img,
    });
  };

  const onBackgroundClick = (e) => {
    if (e) e.stopPropagation();
    setIsVisible(false);
  };

  return (
    <>
      {from === "schedule" && (
        <div className={styles.backdrop} onClick={onBackgroundClick} />
      )}
      <div
        className={`${styles.modal} ${
          from === "schedule" ? styles.centerModal : ""
        }`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className={styles.dropdownList}>
          {map(arr, (ele, index) => {
            return (
              <PlaylistSong
                songName={ele.label}
                dropdownView
                dropdownDaysView
                id={ele.value}
                setSelectedPlaylist={setSelectedPlaylist}
                dropDown={styles.weekDays}
                dropdownContainer={styles.container}
                key={`ele.value${index}`}
              />
            );
          })}
        </div>
        <div className={styles.dropDown}>
          <Dropdown
            defaultValue={scheduleConstants.HOURS[0]}
            arr={scheduleConstants.HOURS}
            setValue={handleSetPlayingHour("hours")}
            suffix=""
          />
          <Dropdown
            defaultValue={scheduleConstants.MINS[0]}
            arr={scheduleConstants.MINS}
            setValue={handleSetPlayingHour("mins")}
            suffix=""
          />
          <Dropdown
            defaultValue={scheduleConstants.TIME_TYPE[0]}
            arr={scheduleConstants.TIME_TYPE}
            setValue={handleSetPlayingHour("type")}
          />
        </div>
        <div className={styles.btnWrapper}>
          <Button
            onClick={handleSave}
            isLoading={isLoading}
            className={styles.button}
            disabled={userOffline}
          >
            Save
          </Button>
        </div>
      </div>
    </>
  );
};

export default ScheduleToPlaySongPopUp;
